const updateTopPerformers = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const { teamMap } = action?.data || {};
            const {
                gamePk,
                liveData: {
                    boxscore: {
                        topPerformers
                    } = {}
                } = {}
            } = action?.data || {};
            const sportId = teamMap?.home?.team?.sport?.id;
            return {
                ...state,
                sportId,
                players: topPerformers,
                gamePk
            };
        } else if (datasource === 'spotlightGame') {
            const { players = [] } = action?.data || {};

            return {
                ...state,
                players: players.length < 4 ? players : players.slice(0, 3),
                isLoadingTopPerformers: false
            };
        } if (datasource === 'playerStory') {
            const { playerStories } = action?.data;
            const { players } = state;
            const updatedPlayers = players?.map((player) => {
                const { story, hasStory } = playerStories?.[player.id] || player || {};
                return {
                    ...player,
                    story,
                    hasStory
                };
            });
            return { ...state, players: updatedPlayers, isLoadingStories: false };
        }
    } if (type === 'top_performer_loading') {
        const { isLoadingStories, isLoadingTopPerformers } = action?.data;
        return { ...state, isLoadingStories, isLoadingTopPerformers };
    }

    return state;
};

export default updateTopPerformers;
